import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  endAdornmentRtl: {
    left: 0,
    right: "auto",
  },

  hasPopupIconRtl: {
    "& .MuiAutocomplete-inputRoot": {
      paddingLeft: 30,
      paddingRight: 0,
    },

    "&.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot": {
      paddingRight: 0,
      paddingLeft: 56,
    },
  },

  hasClearIcon: {
    "& .MuiAutocomplete-inputRoot": {
      paddingLeft: 30,
      paddingRight: 0,
    },
  },

  inputRoot: {},
}));

const IntlAutocomplete = (props) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  return (
    <Autocomplete
      {...props}
      classes={{
        endAdornment: clsx({
          [classes.endAdornmentRtl]: i18n.dir() === "rtl",
        }),
        hasPopupIcon: clsx({
          [classes.hasPopupIconRtl]: i18n.dir() === "rtl",
        }),
        hasClearIcon: clsx({
          [classes.hasClearIconRtl]: i18n.dir() === "rtl",
        }),
      }}
    />
  );
};

export default IntlAutocomplete;
